import { projectToCRS } from "@nova/calculate-geospatial"
import { FeatureCollection } from "geojson"
import { getPropertiesForHotspots } from "../hotspotProperties"
import { HotspotWithLabel } from "@nova/constants"

export const hotspotTransformer = (hotspots: HotspotWithLabel[], projection?: string) => {
    const properties = getPropertiesForHotspots(hotspots)
    const json = {
        type: "FeatureCollection",
        features: hotspots
            .map((hotspot, i) => {
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: projectToCRS(
                            [hotspot.longitude, hotspot.latitude],
                            projection
                        ),
                    },
                    properties: properties[i],
                } as const
            })
            .sort(
                (a, b) =>
                    parseInt(a.properties?.id.split("-").at(-1) || "0") -
                    parseInt(b.properties?.id.split("-").at(-1) || "0")
            ),
    } satisfies FeatureCollection

    return json
}
